// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7b4a289e","453":"d37b4cc7","932":"adc6e230"}[chunkId] + ".chunk.js";
};